import React, { useRef, useState, useEffect } from 'react';
import { useTheme } from '../hooks/useTheme';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

type DateInputProps = {
    name: string;
    value: string;
    setValue: (value: string) => void;
    paddingBlock?: string;
    required?: boolean;
    disabled?: boolean;
}

const TimeInput = ({
    name,
    value,
    setValue,
    paddingBlock = "8px",
    required = false,
    disabled
}: DateInputProps) => {
    const timeRef = useRef<HTMLInputElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const { themeStyles } = useTheme();
    const [displayTime, setDisplayTime] = useState<string>("");

    useEffect(() => {
        setDisplayTime(value || "__:__");
    }, [value]);

    return (
        <div className="relative">
            <button
                ref={buttonRef}
                type="button"
                disabled={disabled}
                className={`w-full px-[8px] py-[${paddingBlock}] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none text-sm text-left bg-transparent ${themeStyles.form.tailwindInputTextColor}`}
                onClick={() => {
                    if (!disabled) timeRef.current?.showPicker();
                }}
                onFocus={() => {
                    buttonRef.current?.classList.add("!border-[#167AC3]");
                }}
                onBlur={() => {
                    buttonRef.current?.classList.remove("!border-[#167AC3]");
                }}
            >
                <span tabIndex={1} className="text-sm tracking-wide">
                    {displayTime}
                </span>

                <AccessTimeIcon
                    style={{ fontSize: 14 }}
                    className="absolute top-1/2 right-[8px] -translate-y-1/2 text-gray-500"
                />
            </button>

            <input
                ref={timeRef}
                type="time"
                name={name}
                className="absolute inset-0 opacity-0 -z-10 pointer-events-none"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                tabIndex={-1}
                required={required}
                disabled={disabled}
            />
        </div>
    );
}

export default TimeInput;